import { appVariant } from '@util/AppUtils';
import { Environment } from '@util/Environment';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
/**
 * These values are used in config pass to the firebase.initializeApp(config) call
 * To find the values for your app, go to the Firebase Console and select your app,
 * then click on the gear icon and select Project Settings.
 * The values are under the General tab, in the Your Apps section.
 * As this is Web Assessment, the relevant values are in the "Web apps" section, not the "iOS" or "Android" sections.
 */
const DEVELOPMENT_CONFIG = {
  apiKey: 'AIzaSyAcd-OuKmlDdnAduhp4xXMoP9Rq9x3pLzk',
  authDomain: 'dev.auth.mindsethealth.com',
  databaseURL: 'https://nerva-dev.firebaseio.com',
  projectId: 'nerva-dev',
  storageBucket: 'nerva-dev.appspot.com',
  appId: appVariant({
    meno: '1:873414796184:web:f82fa2839ea6429c9b41ed',
    nerva: '1:873414796184:web:856d785cee66202f9b41ed',
    quit: '1:873414796184:web:e526f216f2c59b7b9b41ed',
    pain: '1:873414796184:web:24cd31ebb576e9a69b41ed',
  }),
  measurementId: appVariant({
    meno: 'G-VQ97Q6QVLL',
    nerva: 'G-YKFFXGR2N2',
    quit: 'G-X9EGF7Y0YM',
    pain: 'G-F0TYEPKT44',
  }),
} as const;

const PRODUCTION_CONFIG = {
  apiKey: 'AIzaSyAWkIA5RbvYnD-JNI39_s8eOPD_TjIm_Go',
  authDomain: 'dev.auth.mindsethealth.com',
  databaseURL: 'https://ibs-app-d4d2a.firebaseio.com',
  projectId: 'ibs-app-d4d2a',
  storageBucket: 'ibs-app-d4d2a.appspot.com',
  messagingSenderId: '548863453229',
  appId: appVariant({
    meno: '1:548863453229:web:e4c5d0fd841ede6beb70a4',
    nerva: '1:548863453229:web:cef890d736cbaa2feb70a4',
    quit: '1:548863453229:web:04d20fb9be49cf42eb70a4',
    pain: '1:548863453229:web:5b286799d0e456feeb70a4',
  }),
  measurementId: appVariant({
    meno: 'G-DPYVK19J8T',
    nerva: 'G-R5Q5XYWWKW',
    quit: 'G-GVV27MWCWC',
    pain: 'G-S41VY7PGNF',
  }),
} as const;

type InitializeParams = {
  integrationTests?: boolean;
};

type FirebaseProjectId = (typeof DEVELOPMENT_CONFIG | typeof PRODUCTION_CONFIG)['projectId'];

/**
 * Custom domains fronting the Cloud Functions with a Google load balancer + Cloud Armor. Keyed by
 * Firebase project rather than environment because staging shares the production project. Projects
 * not listed keep using the default cloudfunctions.net URLs.
 */
const FUNCTIONS_CUSTOM_DOMAIN: Readonly<Partial<Record<FirebaseProjectId, string>>> = {
  'nerva-dev': 'https://api-dev.mindsethealth.com',
  'ibs-app-d4d2a': 'https://api.mindsethealth.com',
};

let initializedFunctionsDomain: string | undefined;

function initialize(params?: InitializeParams): void {
  const config =
    Environment.DEVELOPMENT || params?.integrationTests ? DEVELOPMENT_CONFIG : PRODUCTION_CONFIG;
  initializedFunctionsDomain = FUNCTIONS_CUSTOM_DOMAIN[config.projectId];
  firebase.initializeApp(config);
}

/** Functions instance for the initialized project, routed via the custom domain when one exists. */
function functions(): firebase.functions.Functions {
  return firebase.app().functions(initializedFunctionsDomain);
}

export const Firebase = {
  initialize,
  functions,
};
